var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgThickness = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 70,
  height: 70
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 3704",
  transform: "translate(-30 -1884)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 35,
  cy: 35,
  r: 35,
  fill: "#ebebeb",
  "data-name": "Ellipse 676",
  transform: "translate(30 1884)"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 3584"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 3581",
  opacity: 0.5
}, /*#__PURE__*/React.createElement("path", {
  fill: "#707070",
  d: "m73.365 1923.804 1.143-1.143-3.713-3.721 3.713-3.722-1.143-1.143-4.865 4.865Z",
  "data-name": "Path 4411"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#707070",
  strokeWidth: 1.5,
  d: "M69.508 1918.939h15",
  "data-name": "Line 1709"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 3582",
  opacity: 0.5
}, /*#__PURE__*/React.createElement("path", {
  fill: "#707070",
  d: "m56.139 1923.804-1.143-1.143 3.713-3.722-3.713-3.721 1.143-1.143 4.865 4.864Z",
  "data-name": "Path 4411"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#707070",
  strokeWidth: 1.5,
  d: "M59.996 1918.939H45",
  "data-name": "Line 1709"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 3583",
  transform: "translate(6143 7769)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#0e2240",
  d: "M-6076-5866.425v33a4 4 0 0 1-4-4v-25a4 4 0 0 1 4-4",
  "data-name": "Rectangle 4698"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#0e2240",
  d: "m-6074.831-5879 .939.132-2.313 16.457-.939-.132z",
  "data-name": "Rectangle 4700"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#0e2240",
  d: "m-6073.892-5820.335-.939.132-2.313-16.457.94-.132z",
  "data-name": "Rectangle 4701"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 0.948,
  cy: 0.948,
  r: 0.948,
  fill: "#fff",
  "data-name": "Ellipse 683",
  transform: "translate(-6079 -5850.925)"
}))))));
export { SvgThickness as ReactComponent };
export default "/_next/static/images/thickness.svg";